import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Icon,
  Button,
} from '@printdeal/ui-library';

interface SubmitButtonProps {
  isValid: boolean;
  isSubmitting: boolean;
  mutationPending: boolean;
}

const SubmitButton = ({ isValid, isSubmitting, mutationPending }: SubmitButtonProps) => (
  <div className="pd-w-full pd-text-right">
    <div className="pd-inline-flex pd-flex-col pd-items-end pd-gap-4">
      <Button
        type="submit"
        disabled={!isValid || isSubmitting || mutationPending}
        data-cy="request-quote-form"
        isLoading={isSubmitting || mutationPending}
      >
        <FormattedMessage id="account.quotes.form.button.submit" defaultMessage="Request quote" />
      </Button>
      <span className="pd-flex pd-items-center pd-gap-2 pd-text-sm">
        <Icon icon="check-orange" className="pd-h-4 pd-w-4" />
        <FormattedMessage id="account.quotes.form.button.nonbinding.label" defaultMessage="Requesting a quote is non-binding." />
      </span>
    </div>
  </div>
);

export default SubmitButton;
